import { useContext } from 'react';
import { TenantContext, type Tenant } from '../context/tenant-context.ts';

export function useTenant(): Tenant {
    const tenant = useContext(TenantContext);

    if (!tenant) {
        throw new Error('useTenant must be used within a TenantContext provider');
    }

    return tenant;
}
